<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 29/10/2021
  -->

<template>
	<el-empty v-bind="attrsStylesClass">
		<template #image v-if="$slots.image || hideImage">
			<div v-if="hideImage"></div>
			<slot v-else name="image"></slot>
		</template>
		<template #description>

			<div class="font-size-6">
				<slot name="description">
					<slot name="title"/>
					<div class="font-size-3 mt-3">
						<slot name="sub-title"/>
					</div>
					<div class="font-size-2 mt-3">
						<slot name="sub-title-small"/>
					</div>
				</slot>
			</div>
		</template>

		<slot name="button" v-bind="{'onAction': buttonClickListener}">
			<qw-button-main v-if="!hideActionButtonComputed" @click="buttonClickListener">
				<slot name="button-title">{{ actionTitle }}</slot>
			</qw-button-main>
		</slot>

	</el-empty>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwEmpty",
	extends: BaseComponent,
	inheritAttrs: false,

	props: {
		actionTitle: {String, default: "Click"},
		hideActionButton: Boolean,
		hideImage: Boolean,
	},

	computed: {
		buttonClickListener() {
			return this.$attrs['onAction'] || (() => {})
		},

		buttonAttrs() {
			return {type: "primary"}
		},
		buttonClasses() {
			return "font-size-4 py-3 px-5"
		},

		hideActionButtonComputed() {
			return this.hideActionButton || !this.$attrs['onAction']
		}

	},

}
</script>

<style lang="scss">

</style>
